module.exports = __webpack_public_path__ + "img/roll-it-back-button.1bc15d72.svg";